module.exports = __webpack_public_path__ + "img/vest_3.42a249fb.png";